import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DisableClickToCallIntegration as DisableClickToCallIntegrationMutation} from 'nutshell-graphql-types';

import DISABLE_CLICK_TO_CALL_INTEGRATION from '../mutations/disable-click-to-call-integration.graphql';

export const useDisableClickToCallIntegration = (): {
    disableClickToCallIntegration: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [disableClickToCallIntegration, {loading, error}] = useMutation<
        DisableClickToCallIntegrationMutation,
        Record<any, any>
    >(DISABLE_CLICK_TO_CALL_INTEGRATION, {});

    return {
        disableClickToCallIntegration: () => disableClickToCallIntegration(),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
